import { ajax } from 'cadenza/api-client/api';
import type { LayerConfigDto } from 'cadenza/api-client/layer-config-dto';
import { PARAMETER_MAP_SCALE } from 'cadenza/api-client/api-constants';
import { MIMETYPE_JSON } from 'cadenza/model/media-type';

export class LayerConfigApi {

  layerId: string;

  constructor (layerId: string) {
    this.layerId = layerId;
  }

  getConfig (mapScale: number): Promise<LayerConfigDto> {
    const params = new URLSearchParams();
    params.append(PARAMETER_MAP_SCALE, mapScale.toString());
    return ajax(this._configPath + `?${params}`);
  }

  setConfig (config: object, mapScale: number) {
    const params = new URLSearchParams();
    params.append(PARAMETER_MAP_SCALE, mapScale.toString());
    return ajax(this._configPath + `?${params}`, {
      type: 'PUT',
      contentType: MIMETYPE_JSON,
      data: JSON.stringify(config)
    });
  }

  get _configPath (): string {
    return `/layers/${this.layerId}/configuration`;
  }

}
